export type Listing = {
  id: number
  name: string
  handle?: string
  url: string
  category: string
  description: string
  bid: number
  clicks: number
  time: string
  accent: string
  initials: string
  imageUrl?: string
  iconUrl?: string
}

export type TargetPreview = {
  targetUrl: string
  targetHost: string
  title: string
  description: string
  imageUrl: string | null
  iconUrl: string | null
}

export const formatAED = (amount: number) => `AED ${amount.toLocaleString('en-AE')}`
